import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import DetailsTabs from "./components/tabs";
import Button from "@material-ui/core/Button";
import Domain from "@material-ui/icons/Domain";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import DetailsInfo from "./components/info";
import { useAttendanceLocalDepartmentDetails } from "../../../../../../../services/api-tansquery/attendance-local/department/details";
import { useBreadcrumbs } from "../../../../../../../contexts/breadcrumb";
import { useAttendanceLocalDepartmentDetailsStyles } from "./styles";


export default function AttendanceLocalDepartmentDetails() {
    const history = useHistory();
    const { setBreadcrumbs } = useBreadcrumbs();
    const { id } = useParams<{ id: string }>();
    const { classes } = useAttendanceLocalDepartmentDetailsStyles();
    const { data: department } = useAttendanceLocalDepartmentDetails(Number(id));

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Locais de Atendimento",
                    path: "/locais-de-atendimento",
                    icon: Domain
                },
                {
                    label: "Setor",
                    path: "",
                }
            ]
        });
    }, [setBreadcrumbs]);

    return (
        <Box className={classes.root}>
            <Box>
                <Button
                    className={classes.backButton}
                    startIcon={<ChevronLeft />}
                    onClick={() => history.goBack()}
                >
                    Voltar
                </Button>
            </Box>
            <DetailsInfo department={department} />
            <DetailsTabs department={department} />
        </Box >
    );
}
